import React from "react";
import { MessageCircle } from "lucide-react";
import { useSiteStatus } from "../context/SiteStatusContext";
import { trackWhatsAppClick } from "../lib/analytics";

const WHATSAPP_NUMBER = "919220573477";

export function WhatsAppButton() {
  const { status } = useSiteStatus();
  const msg = status?.whatsapp_prefill_message || "Hi Begum's Biryani Secrets, I'd like to place an order.";
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackWhatsAppClick()}
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed z-40 bottom-24 right-4 lg:bottom-6 lg:right-6 group flex items-center"
    >
      <span className="absolute inline-flex h-14 w-14 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-200 group-hover:scale-105">
        <MessageCircle size={26} fill="white" strokeWidth={0} />
      </span>
      <span className="hidden lg:block absolute right-16 whitespace-nowrap bg-navy text-cream text-xs font-medium px-3 py-1.5 rounded-full shadow-lg opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200">
        Chat with us
      </span>
    </a>
  );
}
